import Axios from 'axios'
import {
	IPricesListsUpdateApply,
	IPricesListsUpdatePaginate,
	IPricesListsUpdateRecord
} from 'models/PricesListsMassiveUpdate'

export const pricesListsUpdateApply = async (
	params: IPricesListsUpdateApply
) => {
	const response = await Axios.post(`inv_mod_lprec/aplicar`, params)
	return response.data
}
export const pricesListsUpdateRecord = async (
	params: IPricesListsUpdateRecord
) => {
	const response = await Axios.post(`inv_mod_lprec/grabar`, params)
	return response.data
}
export const pricesListsUpdatePaginate = async (
	params: IPricesListsUpdatePaginate
) => {
	const response = await Axios.post(`inv_mod_lprec/paginar`, params)
	return response.data
}
